import space from '@/client/components/theme/space'
import styled from 'styled-components'

export const SearchBox = styled.form``

export const Divider = styled.div`
  margin-bottom: 4rem;
`
export const SearchIcon = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${space.sm};
  width: ${space.xl2};
  height: ${space.xl2};
`
export const SearchIconWrapper = styled.div``
